<template>
    <ul class="list-group p-0 w-100">
        <slot></slot>
    </ul>    
</template>

<script>
export default {
    name:"ListGroup"
}
</script>

<style lang="css" scoped>
    @import"../../assets/css/_colors";
</style>
